import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerPrivacyService } from './customer-privacy.service';
import { CustomerPrivacyCategory } from './mask-data';
import { transform } from './transformer';

@Pipe({ name: 'ceCustomerPrivacy', pure: false })
@UntilDestroy()
export class CustomerPrivacyPipe implements PipeTransform {
    constructor(
        private customerPrivacy: CustomerPrivacyService,
        private cdRef: ChangeDetectorRef
    ) {
        this.customerPrivacy.enabled$.pipe(untilDestroyed(this)).subscribe(() => {
            this.cdRef.markForCheck();
        });
    }

    transform(original: string[], category: CustomerPrivacyCategory): string[];
    transform(original: string, category: CustomerPrivacyCategory): string;
    transform(original: string | string[], category: CustomerPrivacyCategory): string | string[] {
        if (this.customerPrivacy.enabled) {
            return transform(original as any, category);
        } else {
            return original;
        }
    }
}
